export class AppConstant{

    public static get baseURL():string{

        return 'https://api.frranky.com/';
    }
}